"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontSizes = void 0;
exports.fontSizes = {
    fontSize1: 10,
    fontSize2: 12,
    fontSize3: 14,
    fontSize4: 16,
    fontSize5: 18,
    fontSize6: 24,
    fontSize7: 32,
    fontSize8: 48,
};
//# sourceMappingURL=fontSizes.js.map